define('model/person.user.model',['require','exports','module','fukit/fukit'],function(require, exports, module) {
  var BaseModel = require('fukit/fukit').BaseModel;

  var PersonUserModel = BaseModel.extend({
    radioRequests: {
      'models PersonUserModel': '@constructor',
    },

    urlRootTemplate: '/api/v2/person/:personId/user',

    virtual: {
      fullName: {
        deps: ['firstName', 'lastName'],
        get: function() {
          return (this.get('firstName') || '') + ' ' + (this.get('lastName') || '');
        },
      },
    },
  });
  module.exports = PersonUserModel;
});

